// A layout for the tracking export (owner, 2026-09-18): the viewer's
// capture with a title band on top and the legend drawn underneath, so
// the picture reads on its own in the PDF, in Excel, or forwarded alone.
// Every element not yet given a status is the grey halftone; the tracked
// ones carry their status colour.
import { STATUS_COLOR, STATUS_LABEL, STATUS_ORDER } from "./trackingTheme";

const GHOST = "#B8BEC4";

const loadImage = (src) => new Promise((resolve, reject) => {
  const img = new Image();
  img.onload = () => resolve(img);
  img.onerror = reject;
  img.src = src;
});

export async function composeLayout(dataUrl, { title = "", subtitle = "", byStatus = {}, maxWidth = 2400, quality = 0.88 } = {}) {
  if (!dataUrl) return null;
  const img = await loadImage(dataUrl);
  const w = Math.min(maxWidth, img.naturalWidth || img.width);
  const h = Math.round(((img.naturalHeight || img.height) * w) / (img.naturalWidth || img.width));
  const unit = Math.max(1, w / 1600);
  const head = Math.round(64 * unit);
  const foot = Math.round(56 * unit);
  const canvas = document.createElement("canvas");
  canvas.width = w; canvas.height = h + head + foot;
  const g = canvas.getContext("2d");
  g.fillStyle = "#FFFFFF"; g.fillRect(0, 0, canvas.width, canvas.height);
  g.drawImage(img, 0, head, w, h);
  g.fillStyle = "#23343E";
  g.font = `600 ${Math.round(24 * unit)}px Arial, sans-serif`;
  g.fillText(title, Math.round(20 * unit), Math.round(34 * unit));
  if (subtitle) {
    g.fillStyle = "#6B7280";
    g.font = `${Math.round(15 * unit)}px Arial, sans-serif`;
    g.fillText(subtitle, Math.round(20 * unit), Math.round(56 * unit));
  }
  // The legend: the four statuses with their counts, then the halftone.
  const items = [
    ...STATUS_ORDER.map((s) => ({ color: STATUS_COLOR[s], label: `${STATUS_LABEL[s]}${byStatus[s] != null ? ` (${Number(byStatus[s]).toLocaleString()})` : ""}` })),
    { color: GHOST, label: "Grey halftone: no status yet / not tracked" },
  ];
  let x = Math.round(20 * unit);
  const y = head + h + Math.round(18 * unit);
  const sw = Math.round(18 * unit);
  g.font = `${Math.round(16 * unit)}px Arial, sans-serif`;
  for (const it of items) {
    g.fillStyle = it.color; g.fillRect(x, y, sw, sw);
    g.fillStyle = "#111827"; g.fillText(it.label, x + sw + Math.round(8 * unit), y + sw - Math.round(3 * unit));
    x += sw + Math.round(24 * unit) + g.measureText(it.label).width;
  }
  return canvas.toDataURL("image/jpeg", quality);
}

// Levels in reading order: L1, L2 ... L10, then the rest by name.
export const levelOrder = (a, b) => String(a.name).localeCompare(String(b.name), undefined, { numeric: true, sensitivity: "base" });
